module.exports = __webpack_public_path__ + "img/whatsapp.6559493f.svg";